import Group from './Group';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import formatPrismicData from '../../hocs/formatPrismicData';
import withMediaQueries from '../../hocs/withMediaQueries';

const enhance = compose(
  formatPrismicData,
  withMediaQueries,
  withProps(props => ({
    desktopUp: props.media.desktopUp,
  })),
);

export default enhance(Group);



// WEBPACK FOOTER //
// ./src/client/js/view/components/Group/index.js